<template>
  <div class="topicDetails">
    <div class="topic_ccenter">
      <div class="topic_left">
        <!-- 资源 -->
        <div
          class="file_detail img_box"
          v-if="
            ['jpg', 'png', 'JPEG', 'jpeg', 'GIF', 'gif'].includes(
              sucxinxi.material.suffix
            )
          "
        >
          <img
            v-if="sucxinxi.material.coverUrl == null"
            src="~@/assets/images/login-background.jpg"
            alt=""
          />

          <img
            v-else
            :src="formatUrl(sucxinxi.material.resourceUrl)"
            @click="getImg(formatUrl(sucxinxi.material.resourceUrl))"
            alt=""
          />
        </div>
        <!-- 视频 -->
        <div class="file_detail" v-else-if="sucxinxi.material.suffix == 'mp4'">
          <div
            class="paly_warp"
            v-if="sucxinxi.material.coverUrl !== null && playshow == false"
          >
            <span @click="playvideo" class="icon_play"
              ><i class="el-icon-video-play"></i
            ></span>
          </div>
          <img
            v-if="sucxinxi.material.coverUrl !== null && playshow == false"
            :src="formatUrl(sucxinxi.material.coverUrl)"
            alt=""
          />
          <video
            ref="vidref"
            id="video"
            v-if="sucxinxi.material.coverUrl == null || playshow == true"
            :src="formatUrl(sucxinxi.material.resourceUrl)"
            controls
            controlslist="nodownload"
          ></video>
        </div>
        <!-- 音频 mp3class-->
        <div
          class="file_detail"
          v-else-if="
            sucxinxi.material.suffix == 'mp3' || sucxinxi.material.suffix == 'ogg'
          "
        >
          <img
            v-if="sucxinxi.material.coverUrl == null"
            src="~@/assets/images/login-background.jpg"
            alt=""
          />
          <img v-else :src="formatUrl(sucxinxi.material.coverUrl)" alt="" />
          <audio
            :src="formatUrl(sucxinxi.material.resourceUrl)"
            controls
            controlslist="nodownload"
          >
            您的浏览器不支持 audio 标签。
          </audio>
        </div>
        <!-- 文档ppt等 -->
        <div
          class="file_detail fileppt"
          v-else-if="
            ['txt', 'doc', 'xlsx', 'xls', 'docx', 'ppt', 'pptx', 'pdf'].includes(
              sucxinxi.material.suffix
            )
          "
        >
          <iframe :src="filehtml" frameborder="0" width="100%" height="100%"></iframe>
        </div>
        <div class="file_detail" v-else>
          <img
            :src="formatUrl(sucxinxi.material.coverUrl)"
            @click="getImg(formatUrl(sucxinxi.material.coverUrl))"
            alt=""
          />
        </div>
      </div>
      <div class="topic_right">
        <div v-if="notLitsone == null"></div>
        <div v-else-if="notLitsone.length == 0"></div>
        <!-- 图文 -->
        <div
          class="topic_tuw"
          @click="getNotice(notLitsone[0], 1)"
          v-else
          :style="{ backgroundImage: `url('${notLitsone[0].noticePic}')` }"
        >
          <p class="time_creat">{{ notLitsone[0].createTime }}</p>
          <div class="topicbgling">
            <div class="topic_zhengce">
              <p class="topic_zctitle">{{ notLitsone[0].noticeTitle }}</p>
              <p
                class="topic_alltxt"
                v-html="notLitsone[0].noticeContent.slice(0, 90) + '. . . .'"
              ></p>
            </div>
          </div>
        </div>
        <!-- 推荐 -->
        <div class="topic_tuij">
          <p class="topic_tjtit">相关推荐 <span class="tjxian"></span></p>
          <el-divider></el-divider>
          <div class="emptyall" v-if="filelist.length == 0">
            <el-empty description="暂无相关资源推荐"></el-empty>
          </div>
          <div class="eltjlist" v-else>
            <div class="eltj_item" v-for="(item, index) in filelist" :key="index">
              <p @click="goDetail(item)" :class="index > 2 ? 'pcolor2' : 'pcolor1'">
                0{{ index + 1 }} / {{ item.content.material.title }}
              </p>
            </div>
          </div>
        </div>
        <!-- 相关图片 -->
        <div class="topic_imgs" v-if="tjimgurl9 !== null">
          <el-image class="elimage" :src="tjimgurl9">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nocget } from "@/api/notice.js";
import {
  getLibraryDetails,
  queryES,
  getPros,
  setCollect,
  setReport,
  getDownload,
  yulanUrl,
} from "@/api/library";
export default {
  name: "topicDetails",
  data() {
    return {
      notLitsone: null,
      tjlistdata: [
        { title: "2022河南省郑州市教师招聘考试真题", id: 1 },
        { title: "2022河南省郑州市教师招聘考试真题", id: 1 },
        { title: "2022河南省郑州市教师招聘考试真题", id: 1 },
        { title: "2022河南省郑州市教师招聘考试真题", id: 1 },
        { title: "2022河南省郑州市教师招聘考试真题", id: 1 },
        { title: "2022河南省郑州市教师招聘考试真题", id: 1 },
        { title: "2022河南省郑州市教师招聘考试真题", id: 1 },
        { title: "2022河南省郑州市教师招聘考试真题", id: 1 },
      ],
      baseurl: process.env.VUE_APP_BASE_API,
      sucxinxi: {
        material: {
          title: "",
          pros: "",
          cons: "",
          description: "",
          mediaType: "",
          produceType: "",
          suffix: "pdf",
          fileSize: "",
          createTime: "",
          coverUrl: "",
          resourceUrl: "",
        },
      },
      playshow: false, //视频显示
      filehtml: "", //文件地址
      filelist: [
        {
          content: {
            material: {
              title: "",
              clicks: "",
              suffix: "",
              fileSize: "",
              createTime: "",
              coverUrl: "",
            },
          },
          id: "",
        },
      ],
      tjimgurl9: null, //相关推荐第9个资源，如果有第九个就显示封面
    };
  },
  created() {
    this.yulget();
    this.materialId = this.$route.query.id;
    this.breadtitle = this.$route.query.title;
    if (this.$route.query.tabindex.indexOf(0) > -1) {
      this.$store.commit("user/SET_TABINDEX", this.$route.query.tabindex);
    } else {
      this.$store.commit("user/SET_TABINDEX", Number(this.$route.query.tabindex));
    }
  },
  mounted() {
    //1政策 2公告
    this.getnotlistall(1);
    //详情内容
    this.filedetailsg();
  },
  methods: {
    formatUrl(url) {
      var str = new RegExp("http");
      if (str.test(url)) {
        return url;
      } else {
        return url == null
          ? url
          : url.startsWith("/profile")
          ? this.baseurl + url
          : this.baseurl + "/profile/" + url;
      }
    },
    // 详情
    filedetailsg() {
      getLibraryDetails({
        materialId: this.materialId,
        userId: this.$store.getters.userId,
      }).then((res) => {
        if (res.code == 200) {
          this.sucxinxi = res.data;
          // 文件的额外信息
          this.mediaInfo = JSON.parse(this.sucxinxi.material.mediaInfo);
          // 相关推荐
          this.recommend(this.sucxinxi.material.tag, this.sucxinxi.types);
          //预览
          this.yulan();
        }
      });
    },
    goDetail(item) {
      this.materialId = item.id;
      this.filedetailsg();
      let rourl = this.$router.resolve({
        path: "/topicDetails",
        query: {
          id: item.id,
          title: this.breadtitle,
          tabindex: this.$store.state.user.tabindex,
        },
      });
      window.open(rourl.href);
    },
    // 相关推荐
    recommend(keywords, types) {
      var newObjs = {};
      for (let i = 0; i < types.length; i++) {
        if (types[i].typeBigId == 2 || types[i].typeBigId == 3 || types[i].typeBigId == 4)
          newObjs["big" + types[i].typeBigId] = types[i].typeSmallId;
      }
      let datas = {
        keywords: keywords,
        status: 2,
        types: newObjs,
      };
      queryES(datas, { size: 8, page: 1 }).then((res) => {
        if (res.code == 200) {
          if (res.rows.length >= 8) {
            this.filelist = res.rows.slice(0, 8);
          } else {
            this.filelist = res.rows;
          }
          if (res.rows.length >= 9) {
            this.tjimgurl9 = res.rows[8].content.material.coverUrl;
          } else {
            this.tjimgurl9 = null;
          }
        }
      });
    },
    getnotlistall(noticeType) {
      let params = {
        noticeType: noticeType,
        pageNum: 1,
        pageSize: 1,
      };
      nocget(params).then((res) => {
        this.notLitsone = res.rows;
      });
    },
    getNotice(data, title) {
      let rourl = this.$router.resolve({
        name: "NoticeDetails",
        params: { name: "natice-detail", title, id: data.noticeId },
      });
      window.open(rourl.href);
    },
    // 获取图片的url
    getImg(url) {
      if (url) {
        this.imageSrcLists = [url];
        this.payVoucherDialog = true;
        document.documentElement.style.overflowY = "hidden";
      }
    },
    // 播放
    playvideo() {
      this.playshow = true;
      setTimeout(() => {
        this.$refs.vidref.play();
      }, 500);
    },
    // 预览文档格式资源
    base64encode(str) {
      var base64EncodeChars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
      var out, i, len;
      var c1, c2, c3;
      len = str.length;
      i = 0;
      out = "";
      while (i < len) {
        c1 = str.charCodeAt(i++) & 0xff;
        if (i == len) {
          out += base64EncodeChars.charAt(c1 >> 2);
          out += base64EncodeChars.charAt((c1 & 0x3) << 4);
          out += "==";
          break;
        }
        c2 = str.charCodeAt(i++);
        if (i == len) {
          out += base64EncodeChars.charAt(c1 >> 2);
          out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
          out += base64EncodeChars.charAt((c2 & 0xf) << 2);
          out += "=";
          break;
        }
        c3 = str.charCodeAt(i++);
        out += base64EncodeChars.charAt(c1 >> 2);
        out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4));
        out += base64EncodeChars.charAt(((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6));
        out += base64EncodeChars.charAt(c3 & 0x3f);
      }
      return out;
    },
    yulan() {
      let urlas = window.location.href.split("/#/")[0];
      let fileurl =
        urlas + this.baseurl + "/profile/" + this.sucxinxi.material.resourceUrl;
      let openurl =
        this.$previewurl + "?url=" + encodeURIComponent(this.base64encode(fileurl));
      this.filehtml = openurl;
    },
    //预览地址请求
    yulget() {
      yulanUrl().then((res) => {
        this.$previewurl = res.msg;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.topicDetails {
  width: 100%;

  overflow: hidden;
  background-color: #eeeeee;
  .topic_ccenter {
    width: 1500px;
    margin: 30px auto;
    overflow: hidden;

    .topic_left {
      width: 1070px;
      // min-height: 800px;
      background-color: #ffffff;
      float: left;
      .fileppt {
        width: 100%;
        height: 800px !important;
      }
      .file_detail {
        width: 100%;
        height: 550px;
        position: relative;
        background-color: #fff;

        &.img_box {
          background: #666;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            cursor: pointer;
            height: auto;
            width: auto;
            max-width: 100%;
            max-height: 100%;
          }
        }

        img,
        video {
          width: 100%;
          height: 100%;
        }

        audio {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }

        .paly_warp {
          width: 100%;
          height: 100%;
          background: #000000;
          opacity: 0.25;
          position: absolute;
          z-index: 90;

          .icon_play {
            position: absolute;
            left: 50%;
            top: 50%;
            font-size: 70px;
            color: #fff;
            transform: translate(-50%, -50%);
            cursor: pointer;
          }
        }
      }
    }
    .topic_right {
      width: 350px;
      min-height: 800px;
      background-color: #ffffff;
      float: right;
      padding: 12px 14px;
      .topic_tuw {
        width: 100%;
        height: 222px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
        .time_creat {
          padding: 10px 17px 0 17px;
          font-size: 12px;
          color: #ffffff;
        }
        .topicbgling {
          width: 100%;
          height: 90%;
          background-image: linear-gradient(
            to bottom,
            rgba(70, 64, 184, 0),
            rgba(70, 64, 184, 0.5),
            rgba(70, 64, 184, 0.8),
            rgba(70, 64, 184, 1)
          );
          position: relative;

          .topic_zhengce {
            height: 50%;
            position: absolute;
            bottom: 0;
            color: #ffffff;
            padding: 0 15px;
            font-size: 12px;

            .topic_zctitle {
              word-break: break-all;
              text-overflow: ellipsis;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .topic_alltxt {
              margin-top: 10px;
              word-break: break-all;
              text-overflow: ellipsis;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
      //   相关推荐
      .topic_tuij {
        .topic_tjtit {
          font-size: 16px;
          font-weight: 400;
          padding: 15px 0;
          color: #1d4434;
          position: relative;
          .tjxian {
            display: inline-block;
            width: 140px;
            height: 3px;
            background-color: #1d4434;
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }
        .el-divider--horizontal {
          margin: 0 0 15px 0 !important;
        }
        // 推荐列表
        .eltjlist {
          height: 250px;
          .eltj_item {
            padding: 5px 0;
            cursor: pointer;
            p {
              font-size: 16px;
              font-weight: 400;
              letter-spacing: 1px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .pcolor1 {
              color: #1d4434;
            }
            .pcolor2 {
              color: #c0bfbf;
            }
          }
        }
      }
      // 相关图
      .topic_imgs {
        width: 100%;
        height: 224px;
        margin-top: 15px;
        text-align: center;
        line-height: 224px;

        .elimage {
          width: 100%;
          max-height: 100%;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>
